export default "__VITE_ASSET__433731aa__"